export default __webpack_public_path__ + "static/media/Card-stack-0.2.4abb984e.jpg";